import Vue from 'vue'

export { default as components } from './components'

export const PageHome = Vue.component('page-home', require('./PageHome'))
export const TeachersLanding = Vue.component('teacher-landing', require('./homepage/TeacherLanding.vue'))
export const TeachersFormPage = Vue.component('teachers-form-page', require('./TeachersForm/Index.vue'))
export const TeachersSchoolInformationPage = Vue.component('teachers-school-information', require('./TeachersForm/Forms/SchoolInformation.vue'))
export const TeachersPersonalImpactInformationPage = Vue.component('teachers-personal-impact-information', require('./TeachersForm/Forms/PersonalImpactInformation.vue'))
export const TeachersShippingFormPage = Vue.component('teachers-shipping-form', require('./TeachersForm/Forms/ShippingForm.vue'))
export const TeachersSuccess = Vue.component('teachers-success', require('./TeachersForm/Forms/success.vue'))
export const TeachersLogin = Vue.component('teachers-login', require('./TeachersForm/Login.vue'))



// WEBPACK FOOTER //
// ./resources/js/views/index.js